import { createFileRoute } from "@tanstack/react-router";
import { WishlistPage, wishlistHeadEn } from "@/pages/WishlistPage";

export const Route = createFileRoute("/en/onskeliste")({
  head: wishlistHeadEn,
  component: WishlistPage,
});
